// extracted by mini-css-extract-plugin
module.exports = {"wrap":"status_settings_wrap__19NCm","status":"status_settings_status__3bQh1","statuses":"status_settings_statuses__3RgfJ","add_status":"status_settings_add_status__2tNiQ"};